<div class="container my-5">
    <div class="row justify-content-center">
        <div class="">
            <div class="">

                <div class="register-form">
                    <form [formGroup]="form" (ngSubmit)="submit($event)" novalidate>


                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group required">
                                    <!-- <label class="control-label">{{"first_name"|translate}}</label> -->
                                    <input type="text" name="first_name" class="form-control" formControlName="firstname" [placeholder]="'first_name'|translate" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <!-- <label class="control-label">{{"last_name"|translate}}</label> -->
                                    <input type="text" name="last_name" class="form-control" formControlName="lastname" [placeholder]="'last_name'|translate" autocomplete="off">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-7">
                                <div class="form-group required">
                                    <!-- <label class="control-label">{{"email_address"|translate}}</label> -->
                                    <input type="email" name="email" class="form-control" formControlName="email" [placeholder]="'email_address'|translate" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group required">
                                    <!-- <label class="control-label">{{"mobile"|translate}}</label> -->
                                    <input type="text" name="mobile" class="form-control" formControlName="mobile" [placeholder]="'mobile'|translate" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="form-group required">
                            <!-- <label class="control-label">{{"password"|translate}}</label> -->
                            <input type="password" name="password" class="form-control" formControlName="password" [placeholder]="'password'|translate">
                        </div>
                        <div class="form-group required">
                            <!-- <label class="control-label">{{"confirm_password"|translate}}</label> -->
                            <input type="password" name="confirm_password" class="form-control" formControlName="confirmPassword" [placeholder]="'confirm_password'|translate">
                        </div>

                        <div class="form-group">
                            <mat-slide-toggle (change)="onToggle($event)">{{"register_business"|translate}}</mat-slide-toggle>
                        </div>

                        <div *ngIf="businessUser" formGroupName="businessInfo">
                            <div class="row">
                                <div class="form-group col-md-6 required">
                                    <label class="control-label">{{"company_name"|translate}}</label>
                                    <input type="text" name="company" class="form-control" aria-required="" formControlName="name" required autocomplete="off">
                                </div>
                            </div>

                            <div class="form-group required">
                                <label>{{"cr_copy"|translate}}</label>
                                <div class="input-group mb-3">
                                    <input #crCopy type="file" class="form-control"  (change)="handleFileInput('businessInfo.cr',$event.target.files)" >
                                    <div class="input-group-append">
                                        <span class="input-group-text" >
                                            <button  type="button" class="close pull-right" aria-label="Close" (click)="remove('businessInfo.cr',crCopy)">
                                                <app-icon name="cross-20" size="20"></app-icon>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group required">
                                <label>{{"vat_certificate"|translate}}</label>
                                <div class="input-group mb-3">
                                    <input #vatCopy type="file" class="form-control" (change)="handleFileInput('businessInfo.vatCert',$event.target.files)">
                                    <div class="input-group-append">
                                        <span class="input-group-text" >
                                            <button  type="button" class="close pull-right" aria-label="Close" (click)="remove('businessInfo.vatCert',vatCopy)">
                                                <app-icon name="cross-20" size="20"></app-icon>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="controls row">
                            <button type="submit" class="btn btn-primary">{{"register"|translate}}</button>
                            <!-- <button type="submit" class="btn btn-primary mx-1" (click)="loginForm()">{{"login"|translate}}</button> -->
                        </div>
                        <!-- small class="d-block text-center mt-3">
                            <button (click)="register = false"><a class="main-color" [routerLink]="null" >{{"already_have_account"|translate}}</a></button>

                        </small> -->
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
